import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import StructuredData from '@/components/base/StructuredData';
import { categories, featuredContents, faqItems } from '@/mocks/content';

export default function Home() {
  const hotContents = featuredContents.filter((c) => c.isHot);
  const newContents = featuredContents.filter((c) => c.isNew && !c.isHot);

  const organizationLD = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'yy6080',
    url: 'https://dramaslab.github.io',
    description: 'yy6080是一个深受用户喜爱的在线视频平台，提供海量高清影视资源，包括电影、电视剧、动漫等内容，无需注册即可免费观看。',
  };

  const websiteLD = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'yy6080',
    url: 'https://dramaslab.github.io',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://dramaslab.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqLD = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="yy6080官方 - 免费在线观看高清电影电视剧动漫 | yy6080在线观看"
        description="yy6080是一个深受用户喜爱的在线视频平台，提供海量高清影视资源，包括电影、电视剧、动漫等内容，无需注册即可免费观看，支持多终端流畅播放，快来yy6080体验极致观影乐趣。"
        keywords="yy6080,yy6080在线观看,yy6080电影,yy6080最新电视剧,yy6080高清视频,yy6080免费播放,yy6080动漫资源"
        canonicalUrl="https://dramaslab.github.io/"
      />
      <StructuredData data={organizationLD} />
      <StructuredData data={websiteLD} />
      <StructuredData data={faqLD} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20shot%20of%20a%20modern%20home%20theater%20setup%20with%20a%20large%20screen%20displaying%20vibrant%20abstract%20color%20gradients%2C%20cozy%20ambient%20lighting%2C%20comfortable%20seating%2C%20warm%20evening%20atmosphere%2C%20the%20feeling%20of%20movie%20night%2C%20dark%20edges%20with%20soft%20glow&width=1600&height=900&seq=yy6080-hero-bg&orientation=landscape"
              alt="yy6080在线观看 - 免费高清影视平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
                免费在线观看高清影视
              </h1>
              <p className="text-base md:text-xl text-white/80 max-w-2xl mb-8">
                海量电影、电视剧、动漫、综艺资源，无需注册，即点即看
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <Link
                  to="/category/movie"
                  className="px-8 py-3.5 bg-primary-500 text-white rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  开始观看
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3.5 bg-white/15 text-white rounded-full font-medium text-sm hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 w-full bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                  海量内容，应有尽有
                </h2>
                <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                  电影、电视剧、动漫、综艺、纪录片，全网热门资源一网打尽
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 text-center cursor-pointer flex flex-col items-center gap-3"
                  >
                    <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                      <i className={`${cat.icon} text-2xl`}></i>
                    </div>
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                      {cat.name}
                    </span>
                    <span className="text-xs text-foreground-500 leading-relaxed">
                      {cat.description}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Hot Content Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 w-full bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                    热门推荐
                  </h2>
                  <p className="text-sm text-foreground-600">大家都在看的精彩内容</p>
                </div>
                <Link
                  to="/category/movie"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
                {hotContents.map((item) => (
                  <ContentCard key={item.id} item={item} />
                ))}
              </div>
            </div>
          </section>

          {/* New Content Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 w-full bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                    最新上线
                  </h2>
                  <p className="text-sm text-foreground-600">刚刚更新的热门资源</p>
                </div>
                <Link
                  to="/category/tv"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
                {newContents.map((item) => (
                  <ContentCard key={item.id} item={item} />
                ))}
              </div>
            </div>
          </section>

          {/* Features Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 w-full bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                  为什么选择 yy6080
                </h2>
                <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                  用心打造极致观影体验，让每一位用户都能畅享精彩内容
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-vip-diamond-line', title: '完全免费', desc: '所有内容免费观看，无需充值会员，零门槛享受高清影视' },
                  { icon: 'ri-4k-line', title: '超清画质', desc: '支持1080P全高清和4K超清播放，观影体验身临其境' },
                  { icon: 'ri-device-line', title: '多端支持', desc: '电脑、手机、平板全终端适配，随时随地畅享视频' },
                  { icon: 'ri-flashlight-line', title: '极速播放', desc: '智能CDN加速技术，加载快、零卡顿，流畅不等待' },
                ].map((feat, idx) => (
                  <div key={idx} className="text-center p-6">
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                      <i className={`${feat.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                      {feat.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Stats Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 w-full bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { number: '50,000+', label: '影视资源' },
                  { number: '8,000万+', label: '月活用户' },
                  { number: '99.9%', label: '播放成功率' },
                  { number: '24/7', label: '内容更新' },
                ].map((stat, idx) => (
                  <div key={idx} className="text-center py-6 px-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-bold font-heading text-primary-600 mb-1 whitespace-nowrap">
                      {stat.number}
                    </div>
                    <div className="text-sm text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 w-full bg-background-100">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-600">关于 yy6080，你可能想知道的一切</p>
              </div>
              <div className="space-y-3">
                {faqItems.map((faq, idx) => (
                  <FAQItem key={idx} question={faq.question} answer={faq.answer} defaultOpen={idx === 0} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative w-full py-16 md:py-20 px-4 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20wide%20shot%20of%20movie%20projector%20beam%20light%20in%20a%20dark%20theater%2C%20subtle%20dust%20particles%20floating%20in%20light%20beam%2C%20rich%20dark%20gradient%20background%20with%20warm%20golden%20accents%2C%20atmospheric&width=1600&height=600&seq=yy6080-cta-bg&orientation=landscape"
              alt="yy6080观影体验"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50"></div>
            <div className="relative z-10 max-w-2xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-white mb-4">
                即刻开启免费观影之旅
              </h2>
              <p className="text-sm md:text-base text-white/70 mb-8">
                无需注册，无需付费，海量高清影视即刻畅享
              </p>
              <Link
                to="/category/movie"
                className="inline-flex items-center px-8 py-3.5 bg-accent-500 text-white rounded-full font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观看
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}

function ContentCard({ item }: { item: typeof featuredContents[number] }) {
  const categoryLabel = categories.find((c) => c.slug === item.category)?.name || '';

  return (
    <Link
      to={`/article/${item.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${item.title} - yy6080在线观看`}
        />
        <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
          {item.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
              热门
            </span>
          )}
          {item.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
              新上
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
          {item.rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
          <span className="text-white text-xs whitespace-nowrap">{item.episodeInfo}</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-1 whitespace-nowrap">
          {item.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span>{categoryLabel}</span>
          <span>{item.year}</span>
          <span>{item.region}</span>
        </div>
      </div>
    </Link>
  );
}

function FAQItem({ question, answer, defaultOpen }: { question: string; answer: string; defaultOpen: boolean }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
      <button
        className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{question}</span>
        <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-500"></i>
        </div>
      </button>
      <div
        className={`transition-all duration-300 overflow-hidden ${
          open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}